import { render, staticRenderFns } from "./deleteTemplate.vue?vue&type=template&id=1fb34c58&"
import script from "./deleteTemplate.vue?vue&type=script&lang=js&"
export * from "./deleteTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports